export enum PermissionType {
  Deny,
  Allow,
}
